function getForms(state) {
  return state.forms;
}
function getPublishedForms(state) {
  return state.publishedForms;
}
function getFormVersions(state) {
  return state.formVersions;
}
function getFormFetchError(state) {
  return state.editorFormFetchError;
}
function getEditorActiveFormMaster(state) {
  return state.editorActiveFormMaster;
}
function getEditorActiveFormVersion(state) {
  return state.editorActiveFormVersion;
}
function getIsFormSaved(state) {
  return state.formSaved;
}
function getErrorMessage(state) {
  return state.errorMessage;
}

export default {
  getForms,
  getPublishedForms,
  getFormVersions,
  getFormFetchError,
  getEditorActiveFormMaster,
  getEditorActiveFormVersion,
  getIsFormSaved,
  getErrorMessage,
};
